import { ReceivingDisposition } from "@redotech/crdb-enums/fulfillment/receiving-disposition";
import * as z from "zod";

export const RECEIVING_DISPOSITION_PATH =
  "redoManagedReturns.receivingDisposition";

export const receivingDispositionSchema = z.enum(ReceivingDisposition);

export const RECEIVING_DISPOSITION_LABELS: Record<
  ReceivingDisposition,
  string
> = {
  [ReceivingDisposition.Consolidation]: "Consolidation",
  [ReceivingDisposition.Liquidation]: "Liquidation",
};

export function isReceivingDispositionPath(path: string): boolean {
  return path === RECEIVING_DISPOSITION_PATH;
}

export function parseReceivingDispositionValue(
  value: unknown,
): ReceivingDisposition | null {
  return value == null ? null : receivingDispositionSchema.parse(value);
}

export function diffReceivingDisposition(
  stored: ReceivingDisposition | null,
  next: ReceivingDisposition | null | undefined,
): {
  path: string;
  prev: ReceivingDisposition | null;
  next: ReceivingDisposition | null;
}[] {
  if (next === undefined || stored === next) {
    return [];
  }
  return [{ path: RECEIVING_DISPOSITION_PATH, prev: stored, next }];
}
